<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	import '@/assets/css/common.css';
	import '@/assets/css/my_mode.css';
	import '@/assets/font/iconfont.css';
	import {
		sysSelect
	} from '@/utils/systemSelect.js';

	export default {
		name: 'app',
		created: function() {
			this.fun_go_where();
		},
		methods: {
			fun_go_where: function() {
				var now_sys = '';
				now_sys = sysSelect(this);
				// console.log('去哪里.............' + now_sys);
				if (now_sys == 'YD') {
					// window.open('http://yd.sxrhkj.cn/');
					// window.location.assign('http://yd.sxrhkj.cn/');

					// console.log('我要去移动界面');
					
					let o = {};
					o.key = 'error';
					o.val = '请在电脑端打开界面';
					let parm = o;
					
					this.$router.push({
						path: "/error"  ,
						query: parm
					}).catch(err => err);
				}

				// 加一次2秒后判断
			}
		},
		beforeDestroy: function() {
			//Vue 实例销毁之前调用。在这一步，实例仍然完全可用。
			localStorage.clear();
		}
	}
</script>

<style>
	#app {
		/* font-family: "Avenir", Helvetica, Arial, sans-serif, "宋体"; */
		font-family: "Helvetica Neue", Helvetica, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		/* text-align: center; */
		color: black;
	}

	/* 修改饿了么消息提示位置 */
	.el-message {
		margin-top: 8px;
	}


	/* 修改饿了么树形图位置 */
	.el-tree {
		background-color: #051214;
		color: rgb(252, 249, 249);
	}



	.el-tree-node:focus>.el-tree-node__content {
		background-color: #1414e0 !important;
		color: rgb(252, 249, 249) !important;
	}

	/* .el-tree-node__content:focus{
	  background-color: #050513;
	} */
	.el-tree-node__content:hover {
		background-color: aliceblue;
		color: #050513 !important;
	}

	/* 修改饿了么日期组件位置 */
	.el-input--prefix .el-input__inner {
		padding-left: 30px;
	}

	.el-input--suffix .el-input__inner {
		padding-right: 12px;
		height: 31px;
		line-height: 31px;
	}

	.el-range-editor.el-input__inner {
		margin-left: -5px;
		height: 28px;
		line-height: 28px;
	}

	/* .el-date-editor.el-input,
	.el-date-editor.el-input__inner {
	
	  margin-left: -5px;
	} */

	/* 修改饿了么日期组件图标位置 */
	.el-input__icon,
	.el-date-editor .el-range__icon {
		height: 28px;
		line-height: 28px;
	}

	.el-date-editor .el-range-separator {
		height: 28px;
		line-height: 28px;
	}

	.el-date-editor.el-input,
	.el-date-editor.el-input__inner {
		/* width: 148px; */
		width: auto;
	}

	/* 修改 时间线样式 */
	.el-timeline-item__wrapper {
		position: relative;
		padding-left: 16px;
		top: -3px;
	}

	.el-card__body {
		padding: 5px;
	}

	.el-card p {
		margin-top: 5px;
		margin-bottom: 5px;
	}

	.el-radio {
		margin-right: 2px
	}


	.el-radio-button__inner,
	.el-radio-group {
		vertical-align: sub;
	}

	.el-checkbox {
		margin-top: 8px;
	}

	/* 颜色选择器 */
	.el-color-picker {
		height: 28px;
	}

	.el-color-picker__trigger,
	.el-color-picker__trigger {
		height: 28px;
		width: 28px;
	}

	.el-tabs__header {
		margin: 0px;
	}
</style>
